






import {Component, Prop, Vue} from 'vue-property-decorator';

type icons = 'comment '
@Component({
  name: 'IconComponent'
})
export default class IconComponent extends Vue {
  @Prop({required: true})
  public name: icons;

  @Prop({required: false})
  public outline: boolean;

  @Prop({required: false})
  public negative: boolean;
}
